import script from "./KendouTermPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouTermPage.vue?vue&type=script&setup=true&lang=js"

import "./KendouTermPage.vue?vue&type=style&index=0&id=d13e878e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d13e878e"]])

export default __exports__